import React from 'react';
import { aboutData } from '../mock';

const About = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="pt-32 pb-24 px-8">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-4xl">
            <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-gray-900 mb-8 leading-[0.95]">
              {aboutData.title}
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 leading-relaxed">
              {aboutData.description}
            </p>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-24 px-8 border-t border-gray-200">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-12">
            {aboutData.stats.map((stat) => (
              <div key={stat.label}>
                <div className="text-5xl md:text-6xl font-bold text-gray-900 mb-3">
                  {stat.number}
                </div>
                <div className="text-sm uppercase tracking-wider text-gray-500">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-24 px-8 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-16">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                Our Approach
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed">
                Our team of dedicated architects, designers, and engineers work collaboratively to deliver projects that not only meet but exceed client expectations. We believe in the power of thoughtful design to create lasting impact on communities and the environment.
              </p>
            </div>
            <div>
              <h3 className="text-sm uppercase tracking-wider text-gray-500 mb-6">Expertise</h3>
              <ul className="space-y-4">
                {aboutData.expertise.map((item) => (
                  <li key={item} className="text-lg text-gray-900">
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-24 px-8">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-16">
            Our Values
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
            {[
              {
                title: 'Purpose-Driven',
                description: 'Every design decision is guided by purpose and functionality.'
              },
              {
                title: 'Innovation',
                description: 'We embrace new technologies and design methodologies.'
              },
              {
                title: 'Excellence',
                description: 'We strive for excellence in every aspect of our work.'
              },
              {
                title: 'Collaboration',
                description: 'Success comes from working closely with our clients.'
              }
            ].map((value) => (
              <div key={value.title}>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{value.title}</h3>
                <p className="text-base text-gray-600 leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;